export default class StepMeta {
  public readonly htmlId: string;
  public readonly cssClass: string;
  public readonly label: string;

  constructor(htmlId: string, cssClass: string, label: string) {
    this.htmlId = htmlId;
    this.cssClass = cssClass;
    this.label = label;
  }
}
